var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C17.9457 80 0 62.0578 0 40C0 17.9422 17.9457 0 40 0C62.0543 0 80 17.9457 80 40C80 62.0543 62.0543 80 40 80ZM40 4.77261C20.5741 4.77261 4.77261 20.5741 4.77261 40C4.77261 59.4259 20.5776 75.2274 40 75.2274C59.4224 75.2274 75.2274 59.4224 75.2274 40C75.2274 20.5776 59.4259 4.77261 40 4.77261Z",
    fill: "url(#paint0_linear_318_690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9981 80C62.0908 80 80 62.0908 80 39.9981C80 17.9054 62.0908 0 39.9981 0C17.9054 0 0 17.9054 0 39.9981C0 62.0908 17.9092 80 40.0019 80H39.9981ZM39.9981 1.88222C61.0169 1.88222 78.114 18.9831 78.114 39.9981C78.114 61.0131 61.0131 78.114 39.9981 78.114C18.9831 78.114 1.88222 61.0169 1.88222 39.9981C1.88222 18.9794 18.9794 1.88222 39.9981 1.88222Z",
    fill: "url(#paint1_linear_318_690)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_690",
    x1: 11.8182,
    y1: 12.7273,
    x2: 64.5455,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#857AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#493F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_690",
    x1: 59.5122,
    y1: 80,
    x2: 20.9756,
    y2: 5.36586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DED8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCarousel);
export default __webpack_public_path__ + "static/media/circle-carousel.5f7090a392b1b5e89c540ae30b23a4d5.svg";
export { ForwardRef as ReactComponent };